const notFoundMessage = 'Not found'

export {
  notFoundMessage
}
